function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.609375 4.37109L0.800781 4.5625C0.855469 4.63542 0.928385 4.67188 1.01953 4.67188C1.11068 4.67188 1.19271 4.63542 1.26562 4.5625L3.53516 2.26562V12.5469C3.53516 12.638 3.5625 12.7109 3.61719 12.7656C3.6901 12.8385 3.77214 12.875 3.86328 12.875H4.13672C4.22786 12.875 4.30078 12.8385 4.35547 12.7656C4.42839 12.7109 4.46484 12.638 4.46484 12.5469V2.26562L6.73438 4.5625C6.80729 4.63542 6.88932 4.67188 6.98047 4.67188C7.07161 4.67188 7.14453 4.63542 7.19922 4.5625L7.39062 4.37109C7.46354 4.29818 7.5 4.22526 7.5 4.15234C7.5 4.0612 7.46354 3.97917 7.39062 3.90625L4.21875 0.734375C4.16406 0.661458 4.09115 0.625 4 0.625C3.90885 0.625 3.83594 0.661458 3.78125 0.734375L0.609375 3.90625C0.536458 3.97917 0.5 4.0612 0.5 4.15234C0.5 4.22526 0.536458 4.29818 0.609375 4.37109Z",
  fill: "currentColor"
});

var SvgArrowUp = function SvgArrowUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 8 13",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-up.6d6cf696.svg";
export { ForwardRef as ReactComponent };